import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { PrefixPath } from "./Navigation";

const PrivateRouteCustomer = ({ children }: any) => {
  const Auth = useSelector((state: any) => state?.UserData?.userData?.isLoginCustomer);
  return Auth ? children : <Navigate to="/" />;
};

export default PrivateRouteCustomer;